import React from 'react'

const CheckOutSuccess = () => {
  return (
    <div>
      <h2>Payment success 🎉🎉</h2>
      <a href="https://ecombackend-n9in.onrender.com/">SHOP AGAIN</a>
    </div>
  )
}

export default CheckOutSuccess
